<script>
	import { store } from "../../store.js";
</script>

<svg
	aria-labelledby={$$props["data-unique_id"] + "_title"}
	aria-describedby={$$props["data-unique_id"] + "_desc"}
	width="27"
	height="28"
	viewBox="0 0 27 28"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<title id={$$props["data-unique_id"] + "_title"}>Grid</title>
	<desc id={$$props["data-unique_id"] + "_desc"}>Grid</desc>
	<g
		class="gridIcon {$store.options[$$props.id].filtres.mode === 'grid'
			? 'active'
			: ''}"
	>
		<rect x="15" y="0.5" width="12" height="12" rx="2" />
		<rect x="15" y="15.5" width="12" height="12" rx="2" />
		<rect y="0.5" width="12" height="12" rx="2" />
		<rect y="15.5" width="12" height="12" rx="2" />
	</g>
</svg>

<style>
	.gridIcon * {
		fill: #888;
		stroke: #888;
		transition: all 0.1s ease-out;
	}
	.gridIcon.active * {
		fill: #3a7c3c;
	}
</style>
